import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';

const TestimonialsCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: 'Sarah Johnson',
      role: 'Supply Chain Director',
      company: 'TechGlobal Inc.',
      image: 'https://public.readdy.ai/ai/img_res/23e0777a3fb9798f25706495b521c5cf.jpg',
      rating: 5,
      text: 'TrackVerse has transformed our logistics operations. Their real-time tracking and reliable service have reduced our shipping costs by 23% while improving delivery times.',
    },
    {
      id: 2,
      name: 'Marcus Chen',
      role: 'CEO',
      company: 'EuroTrade Solutions',
      image: 'https://readdy.ai/api/search-image?query=professional%20asian%20business%20man%20portrait%20headshot%20corporate%20CEO%20smiling%20confident%20natural%20lighting%20simple%20clean%20background%20high%20quality%20photography&width=80&height=80&seq=testimonial-compact-marcus-002&orientation=squarish',
      rating: 5,
      text: 'Exceptional service! Their global network spanning 50+ countries gave us immediate access to markets we thought were too complex to enter. Highly recommended.',
    },
    {
      id: 3,
      name: 'Elena Rodriguez',
      role: 'Operations Manager',
      company: 'FreshFarms International',
      image: 'https://readdy.ai/api/search-image?query=professional%20hispanic%20business%20woman%20portrait%20headshot%20corporate%20manager%20smiling%20warm%20natural%20lighting%20simple%20clean%20background%20high%20quality%20photography&width=80&height=80&seq=testimonial-compact-elena-003&orientation=squarish',
      rating: 5,
      text: 'Their temperature-controlled logistics are perfect for our agricultural exports. Product loss dropped from 8% to less than 1%. Outstanding reliability!',
    },
    {
      id: 4,
      name: 'David Thompson',
      role: 'Logistics Director',
      company: 'BuildRight Materials',
      image: 'https://readdy.ai/api/search-image?query=professional%20mature%20business%20man%20portrait%20headshot%20corporate%20director%20smiling%20confident%20natural%20lighting%20simple%20clean%20background%20high%20quality%20photography&width=80&height=80&seq=testimonial-compact-david-004&orientation=squarish',
      rating: 5,
      text: 'TrackVerse rail logistics solutions have been a game-changer. We achieved 35% cost reduction for bulk materials with excellent tracking visibility.',
    },
    {
      id: 5,
      name: 'Amira Hassan',
      role: 'Procurement Manager',
      company: 'Fashion Forward Group',
      image: 'https://readdy.ai/api/search-image?query=professional%20middle%20eastern%20business%20woman%20portrait%20headshot%20corporate%20manager%20elegant%20smiling%20natural%20lighting%20simple%20clean%20background%20high%20quality%20photography&width=80&height=80&seq=testimonial-compact-amira-005&orientation=squarish',
      rating: 5,
      text: 'Perfect for fashion logistics! They understand tight deadlines and seasonal collections. Sample transit times reduced by 40%. Excellent security measures.',
    },
    {
      id: 6,
      name: 'James Wilson',
      role: 'Import Manager',
      company: 'Global Electronics Ltd',
      image: 'https://readdy.ai/api/search-image?query=professional%20caucasian%20business%20man%20portrait%20headshot%20corporate%20manager%20smiling%20professional%20natural%20lighting%20simple%20clean%20background%20high%20quality%20photography&width=80&height=80&seq=testimonial-compact-james-006&orientation=squarish',
      rating: 5,
      text: 'Reliable, fast, and transparent. TrackVerse handles our electronics shipments with care. Their customs brokerage team is incredibly knowledgeable.',
    },
    {
      id: 7,
      name: 'Priya Sharma',
      role: 'Export Coordinator',
      company: 'Spice Trade Co.',
      image: 'https://readdy.ai/api/search-image?query=professional%20indian%20business%20woman%20portrait%20headshot%20corporate%20coordinator%20smiling%20confident%20natural%20lighting%20simple%20clean%20background%20high%20quality%20photography&width=80&height=80&seq=testimonial-compact-priya-007&orientation=squarish',
      rating: 5,
      text: 'Outstanding air freight services for our time-sensitive spice exports. The 24/7 support team is always responsive and helpful. Very satisfied!',
    },
    {
      id: 8,
      name: 'Robert Martinez',
      role: 'Shipping Manager',
      company: 'AutoParts Direct',
      image: 'https://readdy.ai/api/search-image?query=professional%20latino%20business%20man%20portrait%20headshot%20corporate%20manager%20smiling%20friendly%20natural%20lighting%20simple%20clean%20background%20high%20quality%20photography&width=80&height=80&seq=testimonial-compact-robert-008&orientation=squarish',
      rating: 5,
      text: 'TrackVerse ocean freight is cost-effective and reliable. Their digital platform makes documentation so easy. We have expanded to 15 new markets!',
    },
    {
      id: 9,
      name: 'Sophie Laurent',
      role: 'Logistics Head',
      company: 'Luxury Goods SA',
      image: 'https://readdy.ai/api/search-image?query=professional%20french%20business%20woman%20portrait%20headshot%20corporate%20executive%20elegant%20smiling%20natural%20lighting%20simple%20clean%20background%20high%20quality%20photography&width=80&height=80&seq=testimonial-compact-sophie-009&orientation=squarish',
      rating: 5,
      text: 'Premium service for our high-value shipments. Every package is tracked, insured, and handled with exceptional care. Truly professional team.',
    },
    {
      id: 10,
      name: 'Ahmed Al-Rashid',
      role: 'Trade Director',
      company: 'Middle East Imports',
      image: 'https://readdy.ai/api/search-image?query=professional%20middle%20eastern%20business%20man%20portrait%20headshot%20corporate%20director%20confident%20smiling%20natural%20lighting%20simple%20clean%20background%20high%20quality%20photography&width=80&height=80&seq=testimonial-compact-ahmed-010&orientation=squarish',
      rating: 5,
      text: 'Excellent multi-modal transport solutions. TrackVerse seamlessly coordinates ocean, air, and road transport. Very impressed with their efficiency.',
    },
    {
      id: 11,
      name: 'Lisa Anderson',
      role: 'Supply Manager',
      company: 'Pharma Solutions Inc.',
      image: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20portrait%20headshot%20corporate%20manager%20professional%20smiling%20natural%20lighting%20simple%20clean%20background%20high%20quality%20photography&width=80&height=80&seq=testimonial-compact-lisa-011&orientation=squarish',
      rating: 5,
      text: 'Critical pharmaceutical logistics handled perfectly. Temperature monitoring and compliance documentation are flawless. Highly trustworthy partner.',
    },
    {
      id: 12,
      name: 'Takeshi Yamamoto',
      role: 'Export Manager',
      company: 'Tokyo Manufacturing',
      image: 'https://readdy.ai/api/search-image?query=professional%20japanese%20business%20man%20portrait%20headshot%20corporate%20manager%20smiling%20professional%20natural%20lighting%20simple%20clean%20background%20high%20quality%20photography&width=80&height=80&seq=testimonial-compact-takeshi-012&orientation=squarish',
      rating: 5,
      text: 'TrackVerse provides exceptional service from Asia to global markets. Their tracking system gives us complete visibility. Very professional operation.',
    },
  ];

  const itemsPerView = {
    mobile: 1,
    tablet: 2,
    desktop: 3,
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => {
        const maxIndex = testimonials.length - itemsPerView.desktop;
        return prev >= maxIndex ? 0 : prev + 1;
      });
    }, 5000);

    return () => clearInterval(timer);
  }, [testimonials.length]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - itemsPerView.desktop : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => {
      const maxIndex = testimonials.length - itemsPerView.desktop;
      return prev >= maxIndex ? 0 : prev + 1;
    });
  };

  const handleDotClick = (index: number) => {
    setCurrentIndex(index);
  };

  const totalDots = testimonials.length - itemsPerView.desktop + 1;

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <div className="inline-block px-4 py-2 bg-primary-green/10 rounded-lg text-sm font-semibold text-primary-green uppercase tracking-wider mb-4 whitespace-nowrap">
            Client Reviews
          </div>
          <h2 className="font-heading text-4xl lg:text-5xl text-gray-900 font-bold mb-4">
            What Our Clients Say
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Trusted by businesses worldwide for reliable logistics solutions
          </p>
        </motion.div>

        <div className="relative">
          {/* Testimonials Container */}
          <div className="overflow-hidden">
            <motion.div
              className="flex gap-6"
              animate={{
                x: `calc(-${currentIndex * (100 / itemsPerView.desktop)}% - ${currentIndex * 1.5}rem)`,
              }}
              transition={{
                type: 'spring',
                stiffness: 300,
                damping: 30,
              }}
            >
              {testimonials.map((testimonial) => (
                <motion.div
                  key={testimonial.id}
                  className="flex-shrink-0 w-full lg:w-[calc(33.333%-1rem)]"
                  whileHover={{ y: -5 }}
                  transition={{ duration: 0.2 }}
                >
                  <div className="bg-gray-50 rounded-xl p-6 h-full border border-gray-100 hover:border-primary-blue/30 transition-colors">
                    {/* Rating */}
                    <div className="flex items-center space-x-1 mb-4">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400 text-base"></i>
                      ))}
                    </div>

                    {/* Review Text */}
                    <p className="text-gray-700 text-sm leading-relaxed mb-6">
                      "{testimonial.text}"
                    </p>

                    {/* Author Info */}
                    <div className="flex items-center space-x-3 pt-4 border-t border-gray-200">
                      <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                        <img
                          src={testimonial.image}
                          alt={testimonial.name}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900 text-sm">{testimonial.name}</h4>
                        <p className="text-xs text-gray-600">{testimonial.role}</p>
                        <p className="text-xs text-gray-500">{testimonial.company}</p>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>

          {/* Navigation Controls */}
          <div className="flex items-center justify-center mt-10 space-x-6">
            <button
              onClick={handlePrev}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 hover:bg-primary-blue hover:text-white transition-all cursor-pointer"
              aria-label="Previous testimonials"
            >
              <i className="ri-arrow-left-line text-lg"></i>
            </button>

            {/* Dots */}
            <div className="flex items-center space-x-2">
              {[...Array(totalDots)].map((_, index) => (
                <button
                  key={index}
                  onClick={() => handleDotClick(index)}
                  className={`transition-all cursor-pointer ${
                    index === currentIndex
                      ? 'w-6 h-2 bg-primary-blue rounded-full'
                      : 'w-2 h-2 bg-gray-300 rounded-full hover:bg-gray-400'
                  }`}
                  aria-label={`Go to testimonial group ${index + 1}`}
                />
              ))}
            </div>

            <button
              onClick={handleNext}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 hover:bg-primary-blue hover:text-white transition-all cursor-pointer"
              aria-label="Next testimonials"
            >
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsCarousel;
